module.exports = __webpack_public_path__ + "Raleway-700-Bold.575e4317521b381ac94c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/Raleway-700-Bold.ttf
// module id = ../../../../../src/assets/fonts/Raleway-700-Bold.ttf
// module chunks = styles